export interface Scout {
  id: string;
  name: string;
  url: string;
  enabled: boolean;
  color: string;
}

export const defaultScoutId = 'sophie';
